module.exports = __webpack_public_path__ + "static/media/191.2437d6f8.mp3";